function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "93EF5964-588B-4104-BFAE-C21E081CCF3C@1x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-322.000000, -1194.000000)",
  fill: "#009471"
}, /*#__PURE__*/React.createElement("g", {
  id: "symbol",
  transform: "translate(320.000000, 1192.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C14.268,2 16.406,2.74 18.184,4.141 C18.618,4.483 18.693,5.111 18.351,5.545 C18.01,5.979 17.38,6.053 16.947,5.712 C15.525,4.592 13.814,4 12,4 C7.589,4 4,7.589 4,12 C4,16.411 7.589,20 12,20 C16.411,20 20,16.411 20,12 C20,11.448 20.448,11 21,11 C21.552,11 22,11.448 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z M20.7719,6.793 C21.1629,7.183 21.1629,7.817 20.7719,8.207 L12.2719,16.707 C12.0769,16.902 11.8209,17 11.5649,17 C11.3089,17 11.0529,16.902 10.8579,16.707 L6.8579,12.707 C6.4669,12.317 6.4669,11.683 6.8579,11.293 C7.2489,10.902 7.8809,10.902 8.2719,11.293 L11.5649,14.586 L19.3579,6.793 C19.7489,6.402 20.3809,6.402 20.7719,6.793 Z"
}))));

var SvgConfirmed = function SvgConfirmed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirmed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirmed.8870da75.svg";
export { ForwardRef as ReactComponent };